import { SessionRepository } from "../../infra/repository/session.repository";
import { SessionModel } from "../domain/session";

export class ListSessionUseCase {
    static async execute(workoutId: string): Promise<SessionModel[]> {
        try {
            const response = await SessionRepository.listSessions(workoutId);
            if (response?.error) throw new Error("Erro ao listar sessões");
            return (response.data ?? []).map(
                (item) => new SessionModel(item.id, item.name, item.qrcode, workoutId, item.link ?? "")
            );
        } catch {
            throw new Error("Erro ao listar sessões");
        }
    }
}
